import{renderIcon as e}from"../icon.renderer.js";const n="angle",o=["angle",e({outline:'<path d="M29.52,22.52,18,10.6,6.48,22.52a1.7,1.7,0,0,0,2.45,2.36L18,15.49l9.08,9.39a1.7,1.7,0,0,0,2.45-2.36Z"/>'})];export{o as angleIcon,n as angleIconName};
//# sourceMappingURL=angle.js.map
